import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
        {/* Logo & Description */}
        <div>
          <h2 className="text-2xl font-bold">Food Delivery</h2>
          <p className="mt-2 text-gray-400">
            Empowering the web with creativity and innovation.
          </p>
        </div>
        
        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-semibold mb-3">Quick Links</h3>
          <ul className="space-y-2">
            <li><a href="/" className="text-gray-400 hover:text-white">Home</a></li>
            <li><a href="/" className="text-gray-400 hover:text-white">About</a></li>
            <li><a href="/" className="text-gray-400 hover:text-white">Services</a></li>
            <li><a href="/" className="text-gray-400 hover:text-white">Contact</a></li>
          </ul>
        </div>
        
        {/* Social Media */}
        <div>
          <h3 className="text-xl font-semibold mb-3">Follow Us</h3>
          <div className="flex justify-center md:justify-start space-x-4">
            <a href="/" className="text-gray-400 hover:text-white">Facebook</a>
            <a href="/" className="text-gray-400 hover:text-white">Twitter</a>
            <a href="/" className="text-gray-400 hover:text-white">Instagram</a>
          </div>
        </div>
      </div>
      
      <div className="mt-8 text-center text-gray-500 text-sm">
        &copy; {new Date().getFullYear()} BrandName. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
